import User from "src/models/Base/Auth/User";
import api from "src/services/core/api";

const controllerName = "account";

export const authApi = api.injectEndpoints({
    endpoints: builder => ({
        login: builder.query<User, { username: string, password: string, eImza?: boolean, eImzaId?: string }>({
            query: (request) => {
                var lang = 1;
                switch (localStorage.getItem('lang')) {
                    case "US":
                        lang = 2;
                        break;
                    case "FR":
                        lang = 3;
                        break;
                    case "RU":
                        lang = 4;
                        break;
                    case "AZ":
                        lang = 5;
                        break;
                    case "UZ":
                        lang = 6;
                        break;
                }
                return {
                    url: controllerName + "/login",
                    method: "POST",
                    body: {
                        username: request.username,
                        password: request.password,
                        lang: lang,
                        eImza: request.eImza,
                        eImzaId: request.eImzaId
                    }
                }
            },
            providesTags: ["User"]
        }),
        OrganizasyonSecim: builder.query<User, { userId: number, organizasyonId: number }>({
            query: (request) => {
                return {
                    url: controllerName + "/OrganizasyonSecim",
                    method: "GET",
                    params: request
                }
            }
        })
    }),
})

export const { useLoginQuery, useLazyOrganizasyonSecimQuery } = authApi;